import { __decorate } from "tslib";
import { __metadata } from "tslib";
import { Component, forwardRef, Input, Output, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
var RadioButtonComponent = /*@__PURE__*/ (function () {
    /**
     * TypeScript public modifiers
     */
    function RadioButtonComponent() {
        this.inputValue = '';
        this.onModelChange = new EventEmitter();
        /**
         * Set our default values
         */
        this.localState = { value: '' };
        this.active = false;
        // The internal data model
        this.innerValue = '';
    }
    RadioButtonComponent_1 = RadioButtonComponent;
    Object.defineProperty(RadioButtonComponent.prototype, "value", {
        // get accessor
        get: function () {
            return this.innerValue;
        },
        // set accessor including call the onchange callback
        set: function (v) {
            this.innerValue = v;
            this.onChangeCallback(v);
        },
        enumerable: true,
        configurable: true
    });
    RadioButtonComponent.prototype.clickEvent = function () {
        this.active = true;
        this.writeValue(this.inputValue);
        this.onChangeCallback(this.inputValue);
        if (this.onModelChange) {
            this.onModelChange.emit(this.inputValue);
        }
    };
    // From ControlValueAccessor interface
    RadioButtonComponent.prototype.writeValue = function (value) {
        if (value !== this.innerValue) {
            this.innerValue = value;
        }
    };
    // From ControlValueAccessor interface
    RadioButtonComponent.prototype.registerOnChange = function (fn) {
        this.onChangeCallback = fn;
    };
    // From ControlValueAccessor interface
    RadioButtonComponent.prototype.registerOnTouched = function (fn) {
        this.onTouchedCallback = fn;
    };
    var RadioButtonComponent_1;
    return RadioButtonComponent;
}());
export { RadioButtonComponent };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/shared/components/radio-button/radio-button.component.ts
// module id = null
// module chunks = 